
<div class="garage-door-dimension-legend">
  <img src="/assets/garage_door/widok_od_wewnatrz.png" defaultImg>
  <img class="garage-section" src="/assets/garage_door/przekroj.png" defaultImg>
</div>

<form [formGroup]="dimensionsForm">
  @for (field of fields; track field) {
    @if (field.field) {
      <mat-form-field >
        @if (field.name == 'width') {
          <mat-label translate>GARAGE_DOOR|Szerokość (W)</mat-label>
        }
        @if (field.name == 'height') {
          <mat-label translate>GARAGE_DOOR|Wysokość (H)</mat-label>
        }
        @if (field.name == 'lintelHeight') {
          <mat-label translate>GARAGE_DOOR|Wysokość nadproża (N)</mat-label>
        }
        @if (field.name == 'garageDepth') {
          <mat-label translate>GARAGE_DOOR|Głębokość garażu (D)</mat-label>
        }
        @if (field.name == 'leftJambWidth') {
          <mat-label translate>GARAGE_DOOR|Szerokość ściany lewej (SL)</mat-label>
        }
        @if (field.name == 'rightJambWidth') {
          <mat-label translate>GARAGE_DOOR|Szerokość ściany prawej (SR)</mat-label>
        }
        <input matInput #fieldValue iccDimensionInput step="5" type="number" [formControlName]="field.field">
        <mat-hint class="hint-danger input-validation-hint">
          @if ((fieldValue.value % 5 != 0)) {
            <span>{{'GARAGE_DOOR|Wartość musi być podzielna przez' | translate}} 5<br></span>
          }
          @if (field.min && fieldValue.value < field.min) {
            <span>{{'GARAGE_DOOR|Wartość musi być większa lub równa' | translate}} {{field.min}}<br></span>
          }
          @if (field.max && fieldValue.value > field.max) {
            <span>{{'GARAGE_DOOR|Wartość musi być mniejsza lub równa' | translate}} {{field.max}}</span>
          }
        </mat-hint>
        <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
      </mat-form-field>
    }
  }
</form>
